
import { NotificationPresentationType, HttpResponseCode, NotificationConstants } from '@/types';

export const ErrorReponseConstants = {
  DefaultMStoreExceptionResponseModel: {
    status: HttpResponseCode.InternalServerError,
    notification: '',
    presentationType: NotificationPresentationType.UnexpectedError,
    reference: null
  }
};